// 服务商奖励设置
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="zero">
        <batchView v-if="showEdit2" :_dataId.sync="dataId" :parent-target="_self" visible-key="showEdit2"
                   @editViewDataUpdate="editViewDataUpdate" @reload="$reloadHandle"></batchView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -35px);">
          <vxe-grid ref="table-m1" :row-config="{ isHover: true }" :stripe="true" border="default" height="100%"
                    show-overflow v-bind="vxeOption" @custom="$vxeTableUtil.customHandle"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange">

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button v-if="showAdd" class="button-sty" icon="el-icon-plus" status="primary"
                              @click="openEditDialog2">新增
                  </vxe-button>
                </div>
                <div class="fr">
                  <vxe-button class="button-sty" icon="el-icon-search" status="warning" @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" :data="formData" class="screen-box" title-align="right" title-width="92px"
                        @reset="searchEvent" @submit="searchEvent">
                <vxe-form-item field="code" title="名称:">
                  <template v-slot>
                    <el-input v-model="formData.rewardName" clearable size="small"/>
                  </template>
                </vxe-form-item>
              </vxe-form>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import batchView from './engineerBatch.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {fetchTree} from "@/api/admin/type_tree"
import api from "@/api/projectApi";
import {mapGetters} from "vuex";

export default {
  name: 'formula',

  components: {pager, batchView},
  data() {
    return {
      //权限控制
      showAdd: false,
      showEdit: false,
      total: 0,
      getListPageUrl: '/basic/sfSettleReward/getListPage',
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      showEdit2: false,

      vxeOption: {},
      // 查询参数
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        rewardType:2,
        bigCategoryId: '',
        smallCategoryId: '',
        rewardName: '',
        beginDate: '',
        endDate: '',
        siteId: null,
        itemName: null,
        settleLevel: null,
        stat: null,
        brandId: null,
        date: null,
      },
      formData: {
        bigCategoryId: '',
        smallCategoryId: '',
        rewardName: '',
        beginDate: '',
        endDate: '',
        siteId: null,
        itemName: null,
        settleLevel: null,
        stat: null,
        brandId: null,
        date: null,
      },
      siteName: null,
      brandOptions: [],
      productOptions0: [],
      productOptions1: [],
      itemLits: [],
      pageSizes: [10, 20, 100],
      columns: [
        {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
        {title: '名称', field: 'rewardName', width: 150,},
        {title: '金额', field: 'amount', width: 150,},
        {
          title: '是否生效', field: 'stat', width: 200, slots: {
            default: ({row}) => {
              if (row.stat == 0) {
                return [
                  <div class="txt-status disable">
                    <span>作废</span>
                  </div>
                ];
              } else if (row.stat == 1) {
                return [
                  <div class="txt-status">
                    <span>生效</span>
                  </div>
                ];
              }
            }
          }
        },
        {title: '开始时间', field: 'beginDate', width: 120,},
        {title: '结束时间', field: 'endDate', width: 120,},
        {title: '创建人', field: 'createBy', width: 120,},
        {title: '修改人', field: 'createBy', width: 120,},

        {
          width: 80, fixed: 'right', title: '操作', sortable: false, slots: {
            default: ({row}) => {
              if (this.showEdit) {
                return [
                  < div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog2(row.id);
                      }}
                    >
                      < el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                   popper-class="tooltip-skin">
                        <i
                          class="el-icon-edit"/>
                      </el-tooltip>
                    </a>
                  </div>
                ];
              }
            }
          }
        }
      ]
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    siteName(n) {
      if (!n) {
        this.formData.siteId = null
      }
    },
  },
  created() {
    this.showAdd = this.permissions["formulaAdd"];
    this.showEdit = this.permissions["formulaEdit"];
  },
  methods: {


    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: this.getListPageUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },


    // 搜索
    searchEvent() {
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.requestParam.rewardName = this.formData.rewardName
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 重置
    resetEvent() {
      this.formData = {
        bigCategoryId: '',
        smallCategoryId: '',
        rewardName: '',
        beginDate: '',
        endDate: '',
      }

      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.rewardName = ''
      this.requestParam.bigCategoryId = ''
      this.requestParam.smallCategoryId = ''
      this.requestParam.beginDate = ''
      this.requestParam.endDate = ''

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },
    // 新增
    openEditDialog2(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;

      this.activeName = 'zero';
      this.$openEditView('showEdit2');
    },
    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
      this.activeName = 'second'
    },
  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
